/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
import React, { useState } from 'react';
import {
  ListItemIcon,
  ListItemText,
  Menu, MenuItem,
  Tooltip,
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import ViewIcon from '@material-ui/icons/Visibility';
import { defineMessages, FormattedMessage } from 'react-intl';

import styles from './styles.module.css';

const messages = defineMessages({
  VIEW_ONLY: {
    id: 'VIEW_ONLY',
    defaultMessage: 'View Only',
  },
  ALLOW_EDIT: {
    id: 'ALLOW_EDIT',
    defaultMessage: 'Allow Edit',
  },
});

function AccessControlsMenu({
  option,
  toggleParentClick,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [value, setValue] = useState(0);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const toggleView = () => {
    // eslint-disable-next-line no-param-reassign
    option.allow_edit = false;
    handleClose();
    setValue(value + 1);
  };

  const toggleEdit = () => {
    // eslint-disable-next-line no-param-reassign
    option.allow_edit = true;
    handleClose();
    setValue(value + 1);
  };

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
  };

  const handleMouseEnter = () => {
    toggleParentClick(false);
  };

  const handleMouseLeave = () => {
    setTimeout(() => { // delay re-toggle of parent click to avoid triggering a click event on menu interaction
      toggleParentClick(true);
    }, 500);
  };

  const tooltipMsg = option.allow_edit
    ? <FormattedMessage {...messages.ALLOW_EDIT} />
    : <FormattedMessage {...messages.VIEW_ONLY} />;

  return (
    <>
      <Tooltip disableFocusListener title={tooltipMsg}>
        <div
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          aria-owns={anchorEl ? 'simple-menu' : null}
          aria-haspopup="true"
          onClick={handleClick}
          className={styles.accessControlsContainer}
        >
          {option.allow_edit ? <EditIcon /> : <ViewIcon />}
        </div>
      </Tooltip>

      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        className={styles.accessControlsMenu}
      >
        <MenuItem onClick={toggleView}>
          <ListItemIcon>
            <ViewIcon className={styles.menuIcons} />
          </ListItemIcon>

          <ListItemText
            inset
            primary={<FormattedMessage {...messages.VIEW_ONLY} />}
          />
        </MenuItem>

        <MenuItem onClick={toggleEdit}>
          <ListItemIcon>
            <EditIcon className={styles.menuIcons} />
          </ListItemIcon>

          <ListItemText
            inset
            primary={<FormattedMessage {...messages.ALLOW_EDIT} />}
          />
        </MenuItem>
      </Menu>
    </>
  );
}

export default AccessControlsMenu;
